import { getMentorMatch, updateMentorMatch } from '../api/mentor_matches';

export const updateMatchAndSet = ({ uuid, id, params, setMentorMatch, callback }) => {
  const onSuccess = (data) => {
    setMentorMatch(data);
    sessionStorage.setItem('mentorMatch', JSON.stringify(data));
    if (callback) callback(data);
  };

  if (uuid) {
    updateMentorMatch(uuid, params, onSuccess);
  } else {
    getMentorMatch(id, (match) => {
      updateMentorMatch(match.uuid, params, onSuccess);
    });
  }
};
